import { Route, Switch } from '@hfs/react-router'
import { NoMatch } from '@hfs/website/react/pages/public/NoMatch'
import { getRoute } from '@hfs/website/utils/getRoute'

export const NoMatchRoutes = () => (
  <Switch>
    <Route key={getRoute('*')} component={NoMatch} />
  </Switch>
)
